import { Grid } from '@mui/material'
import React from 'react'
import FeaturesHeroSection from './FeaturesHeroSection'
import FeaturesGridSection from './FeatureGridSection'
import Features from './Features'

export default function FeaturesAllPages() {
  return (
 <Grid>
  <FeaturesHeroSection/>
  <FeaturesGridSection/>
  <Features/>
 </Grid>
  )
}
